export enum DropId {
  AVAILABLE = 'Available',
  ADDED = 'Added',
}
